import {Injectable} from '@angular/core';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {RestServiceAbstract} from "../../../core/base/rest.service.abstract";
import {ResponseModel} from "../../../core/base/response.model";
import {TrackingAllRequest} from "./tracking.all.request";
import {TrackingRequest} from "./tracking.request";

@Injectable({providedIn: 'root'})
export class TrackingRestService extends RestServiceAbstract {

  getAllTours(request: TrackingAllRequest): Observable<ResponseModel> {
    return this.track('/all', request);
  }

  getTours(request: TrackingRequest): Observable<ResponseModel> {
    return this.track('', request);
  }

  getLatestTours(request: TrackingRequest): Observable<ResponseModel> {
    return this.track('/latest', request);
  }

  private track(path: string, body: TrackingAllRequest | TrackingRequest): Observable<ResponseModel> {
    return this.post(`/${this.RESOURCE}/shipmenttracking${path}`, body).pipe(
      map(data => new ResponseModel(data)),
    );
  }
}
